angular.module('impactx.catalog').controller('CatalogExportCtrl', CatalogExportCtrl);

CatalogExportCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    '$route',
    '$mdDialog',
    'DownloadService',
    'ToolbarService',
    '$errorHandler'
];

function CatalogExportCtrl($scope, dataGen, $routeParams, BackService, $mdToast, $route, $mdDialog, DownloadService, ToolbarService, $errorHandler) {
    $scope.view = function () {
        // We use avoidCache here to make sure IE does not cache the GET-Request.
        var dataObj = {
            id: $routeParams.id,
            cattrackId: $routeParams.cattrackId,
            avoidCache: new Date().getTime()
        };
        dataGen.getData($scope, dataObj, "/catalogexport/view").then(function () {
            defineButtons();
            if ($scope.data.targetPriceGroups.entries.length > 0) {
                angular.forEach($scope.data.priceGroupMappings, function (mapping) {
                    if(!impactX.isDefined(mapping, "target")) {
                        mapping.target = $scope.data.targetPriceGroups.entries[0].id;
                    }
                });
            }
        });
    };

    $scope.view();

    $scope.exportBackground = function() {
        if ($scope.validatePriceGroups()) {
            return dataGen.postAsForm($scope, {
                export: $scope.data,
                exportnow: false
            }, "/catalogexport/export").then(function () {
                BackService.back();
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($scope.trns.exportSuccess)
                        .position("bottom right")
                        .hideDelay(10000)
                );
            });
        }
    };

    $scope.exportNow = function(ev) {
        if ($scope.validatePriceGroups()) {
            if ($scope.data.productCount > 500) {
                var exportNow = $mdDialog.confirm()
                    .title($scope.trns.exportNow)
                    .textContent($scope.trns.confirmationExportNow)
                    .ariaLabel('exportNow')
                    .targetEvent(ev)
                    .ok($scope.trns.ok)
                    .cancel($scope.trns.cancel);
                $mdDialog.show(exportNow).then(function () {
                    dataGen.postAsForm($scope, {
                        export: $scope.data,
                        exportnow: true
                    }, "/catalogexport/export").then(function () {
                        $route.reload();
                    });
                }, function () {
                });
            } else {
                return dataGen.postAsForm($scope, {
                    export: $scope.data,
                    exportnow: true
                }, "/catalogexport/export").then(function () {
                    $route.reload();
                });
            }
        }
    };

    $scope.download = function (id) {
        DownloadService.openDownloadPost('/catalogexport/download', {paramName: "id", paramValue: parseInt(id)})
    };

    $scope.validatePriceGroups = function () {
        var result = true;
        var errors = [];
        var warnings = [];
        var targetPriceGroups = [];
        var keepGoing = true;

        angular.forEach($scope.data.priceGroupMappings, function (mapping) {
            if (keepGoing) {
                var isUserDefinedPriceGroup = mapping.target.toLowerCase() === "udp";
                var target = isUserDefinedPriceGroup ? mapping.userDefinedTarget.toLowerCase() : mapping.target.toLowerCase();
                if (target !== "none") {
                    if (isUserDefinedPriceGroup && !target.startsWith("udp_")) {
                        errors.push({error: $scope.trns.userDefinedPriceGroupNotStartsWith});
                        keepGoing = false;
                    }
                    else if (targetPriceGroups.indexOf(target) !== -1) {
                        errors.push({error: $scope.trns.priceGroupsNotUnique});
                        keepGoing = false;
                    } else {
                        targetPriceGroups.push(target);
                    }
                }
            }
        });

        if (targetPriceGroups.length <= 0)
        {
            errors.push({error: $scope.trns.missingPriceGroups});
        }

        if (errors.length > 0 || warnings.length > 0) {
            $errorHandler.showErrors(errors, warnings);
            result = false;
        }
        
        return result;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.export,
                action: $scope.exportBackground,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.exportNow,
                action: $scope.exportNow,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}
